var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { parseTimeFull, parseTimeInMinutes } from "sb-helpers";
import { globalTimeTicker } from "sb-resp-utils";
export var ClockDirection;
(function (ClockDirection) {
    ClockDirection["Stopwatch"] = "Stopwatch";
    ClockDirection["Timer"] = "Timer";
})(ClockDirection || (ClockDirection = {}));
let AutoTimer = class AutoTimer extends React.Component {
    constructor(props) {
        super(props);
        this.time = this.props.gameTime;
        this.timeTicker = globalTimeTicker;
    }
    componentDidUpdate(prevProps) {
        if (this.props.gameTime !== prevProps.gameTime) {
            this.time = this.props.gameTime;
        }
    }
    tick() {
        if (!this.props.clockRunning) {
            return this.time;
        }
        if (this.props.clockDirection === ClockDirection.Stopwatch) {
            return this.time += this.timeTicker.interval;
        }
        if (this.props.clockDirection === ClockDirection.Timer && this.time > 0) {
            return (this.time -= this.timeTicker.interval);
        }
        return 0;
    }
    parseTime() {
        return this.props.includeSeconds ? parseTimeFull(this.tick()) : parseTimeInMinutes(this.tick());
    }
    render() {
        const cls = "rj-auto-timer";
        this.timeTicker.tick;
        return React.createElement("span", { className: cls }, this.parseTime());
    }
};
AutoTimer = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AutoTimer);
export { AutoTimer };
//# sourceMappingURL=AutoTimer.js.map